<template>
  <div class="health_wrapper">
		<search-list
			:provincesArr="provincesArr"
			:mendianCity="mendianCity"
      :transportationArr="transportationArr"
      :temperatureList="temperatureList"
      :throughEpidemicAreaList="throughEpidemicAreaList"
      @search="search"
		></search-list>
		<ul class="num" style="margin:26px 0">
			<li>在住人数：{{detailNum.totalCount}}</li>
			<li>已返回自如寓人数：{{detailNum.returnedCount}}</li>
			<li>今日健康状况已填写数：{{detailNum.recordCount}}</li>
			<li>今日无异常情况数：{{detailNum.healthyCount}}</li>
			<li>今日有异常情况数：<span class="red">{{detailNum.nonHealthyCount}}</span></li>
		</ul>
		<table-list
      :columns="columns"
      :data="data"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changePage"
		></table-list>
		<update
		:n="updateNum"
    :transportationArr="transportationArr"
    :throughEpidemicAreaList="throughEpidemicAreaList"
    :detailData="detailData"
    @done="getSearchData"
		></update>
		<check
    :phone="phone"
    :temperatureList="temperatureList"
    :roomName="roomName"
    :name="name"
    :projectName="projectName"
    :bodyTemperature="bodyTemperature"
    :returnDate="returnDate"
		:n="checkNum"
		></check>
	</div>
</template>

<script>
import searchList from './components/SearchList'
import TableList from 'components/TableList/index';
import Update from './components/Update';
import Check from './components/Check';
import {findByCondition,getProvinces,selectCondition,transportation,statistics} from 'api/customerhealth'

export default {
  components:{
		searchList,
		TableList,
		Update,
		Check
	},
	data(){
		return{
			columns:[
				{
          title:'编号',
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title: '城市',
          align: 'center',
          key: 'cityName',
          width: 100,
        },
        {
          title: ' '
				},
				{
          title: '门店',
          align: 'center',
          key: 'projectName',
          width: 170,
        },
        {
          title: ' '
				},
				{
          title: '房间号',
          align: 'center',
          key: 'roomName',
          width: 100,
        },
        {
          title: ' '
				},
				{
          title: '姓名',
          align: 'center',
          key: 'name',
          width: 100,
        },
        {
          title: ' '
				},
				{
          title: '户籍省份',
          align: 'center',
          key: 'householdRegistrationProvinceName',
          width: 100,
        },
        {
          title: ' '
				},
				{
          title: '户籍城市',
          align: 'center',
          key: 'householdRegistrationCityName',
          width: 100,
        },
        {
          title: ' '
				},
				{
          title: '手机号',
          align: 'center',
          key: 'phone',
          width: 120,
        },
        {
          title: ' '
        },
        {
          title: '是否为已知入住人',
          align: 'center',
          key: 'known',
          width: 100,
          render(h,params){
            let str = ''
            if(params.row['known']=== 'true'){
              str = '是'
            } else if(params.row['known']=== 'false'){
              str = '否'
            } else{
              str = '-'
            }
            return h('span', {}, str)
          }
        },
        {
          title: ' '
				},
				{
          title: '是否进入自如寓居住',
          align: 'center',
          key: 'returned',
          width: 100,
          render(h,params){
            let str = ''
            if(params.row['returned']=== 'true'){
              str = '是'
            } else if(params.row['returned']=== 'false'){
              str = '否'
            } else{
              str = '-'
            }
            return h('span', {}, str)
          }
        },
        {
          title: ' '
				},
				{
          title: '返回/预计返回自如寓日期',
          align: 'center',
          key: 'returnDate',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '返程日体温(℃)',
          align: 'center',
          key: 'bodyTemperature',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '返程交通方式',
          align: 'center',
          key: 'backTransportationTypeName',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '航班号',
          align: 'center',
          key: 'flightNumber',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '车次号',
          align: 'center',
          key: 'trainTrips',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '春节期间是否途径疫情重点地区',
          align: 'center',
          key: 'throughEpidemicArea',
          width: 120,
          render(h,params){
            let str = ''
            if(params.row['throughEpidemicArea']=== 'true'){
              str = '是'
            } else if(params.row['throughEpidemicArea']=== 'false'){
              str = '否'
            } else{
              str = '-'
            }
            return h('span', {}, str)
          }
        },
        {
          title: ' '
        },
        {
          title: '途径情况',
          align: 'center',
          key: 'throughEpidemicAreaDesc',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '1月15日以来是否接触过高危人群',
          align: 'center',
          key: 'reachHighriskGroups',
          width: 130,
          render(h,params){
            let str = ''
            if(params.row['reachHighriskGroups']==='true'){
              str = '是'
            } else if(params.row['reachHighriskGroups']==='false'){
              str = '否'
            } else{
              str = '-'
            }
            return h('span', {}, str)
          }
        },
        {
          title: ' '
				},
				{
          title: '返程信息备注',
          align: 'center',
          key: 'remark',
          width: 120,
        },
        {
          title: ' '
        },
        {
          title: '过去24小时自测体温',
          align: 'center',
          key: 'todayBodyTemperatureDes',
          width: 130,
          render(h,params){
            return h('div',{
              style:{
                color: params.row['todayBodyTemperature'] > 1 ? 'red' : '',
                background:params.row['todayBodyTemperature'] > 1 ? 'pink' : '',
              }
            },params.row['todayBodyTemperatureDes'])
          }
        },
        {
          title: ' '
				},
				{
          title: '过去24小时是否有疑似症状',
          align: 'center',
          key: 'suspectedSymptomsToday',
          width: 130,
          render(h,params){
            let str = ''
            if(params.row['suspectedSymptomsToday']==='true'){
              str = '是'
            } else if(params.row['suspectedSymptomsToday']=== 'false'){
              str = '否'
            } else{
              str = '-'
            }
            return h('div', {
              style:{
                color: params.row['suspectedSymptomsToday'] === 'true' ? 'red' : '',
                background:params.row['suspectedSymptomsToday'] === 'true' ? 'pink' : '',
              }
            },str)
          }
        },
        {
          title: ' '
				},
				{
          title: '过去24小时是否接触过高危人群',
          align: 'center',
          key: 'reachHighriskGroupsToday',
          width: 130,
          render(h,params){
            let str = ''
            if(params.row['reachHighriskGroupsToday']=== 'true'){
              str = '是'
            } else if(params.row['reachHighriskGroupsToday']=== 'false'){
              str = '否'
            } else{
              str = '-'
            }
            return [
              h('div', {
                style:{
                  color: params.row['reachHighriskGroupsToday'] === 'true' ? 'red' : '',
                  background:params.row['reachHighriskGroupsToday'] === 'true' ? 'pink' : '',
                }
              }, str),
            ]
          }
        },
        {
          title: ' '
        },
        {
          title: '过去24小时邻居或室友是否有疑似症状',
          align: 'center',
          key: 'neighbourSuspectedSymptoms',
          width: 150,
          render(h,params){
            let str = ''
            if(params.row['neighbourSuspectedSymptoms']=== 'true'){
              str = '是'
            } else if(params.row['neighbourSuspectedSymptoms']=== 'false'){
              str = '否'
            } else{
              str = '-'
            }
            return [
              h('div', {
                style:{
                  color: params.row['neighbourSuspectedSymptoms'] === 'true' ? 'red' : '',
                  background:params.row['neighbourSuspectedSymptoms'] === 'true' ? 'pink' : '',
                }
              }, str),
            ]
          }
        },
        {
          title: ' '
        },
        {
          title: '邻居的表现症状及房间号',
          align: 'center',
          key: 'symptomHouseNumber',
          width: 120,
        },
        {
          title: ' '
				},
				{
          title: '操作',
          align: 'center',
          width: 150,
          fixed: 'right',
          render:(h,params)=>{
            return [
              h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'customer/health-monitoring/findByCondition'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.$nextTick( ()=> {
                      this.detailData = params.row;
                      this.updateNum++
                    })
                  }
                },
              }, '更新返回信息'),
              h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'customer/health-monitoring/findHelthRecord'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.phone = params.row.phone;
                    this.name = params.row.name;
                    this.roomName = params.row.roomName;
                    this.projectName = params.row.projectName
                    this.returnDate = params.row.returnDate;
                    this.bodyTemperature = params.row.bodyTemperature;
										this.checkNum++
                  },
                },
                style:{
                  display: params.row['returned'] === 'true' ? 'block' : 'none'
                },
              }, '查看健康记录')
            ]
          }
				},
				{
          title: ' '
        },
       
			],
			data:[],
			current:1,
			total:0,
			loading:false,
			limit:10,
			page:1,
			today:'',
			updateNum:0,
			checkNum:0,
			provincesArr:[],
      mendianCity:[],
      transportationArr:[],
      detailNum:{},
      phone:'',
      fid:'',
      name:'',
      projectName:'',
      roomName:'',
      returnDate:'',
      bodyTemperature:0,
      detailData:{},
      temperatureList:[
        {
          value:1,
          text:'37度以内',
        },
        {
          value:2,
          text:'37.1-37.5度低烧',
        },
        {
          value:3,
          text:'37.6-38.5度低烧',
        },
        {
          value:4,
          text:'38.5度以上高烧',
        },
      ],
      throughEpidemicAreaList:[
        {
          value:1,
          text:'途经武汉市',
        },
        {
          value:2,
          text:'途经湖北省其他市区',
        },
        {
          value:3,
          text:'停留武汉市',
        },
        {
          value:4,
          text:'停留湖北省其他市区',
        },
        {
          value:5,
          text:'未途经 未停留'
        }
      ]
		}
	},
	created(){
		this.today = new Date().getTime
		this.getProv();
    this.getCondition();
    this.getTransportation();
    this.getStatistics();
	},
	methods:{
		getProv(){
			getProvinces()
			.then(res=>{
				this.provincesArr = res.data;
			})
			.catch(err=>{
				console.log(err)
			})
		},
		getCondition(){
			selectCondition()
			.then(res=>{
				this.mendianCity = res.data.city;
			})
			.catch(err=>{
				console.log(err)
			})
    },
    getTransportation(){
      transportation()
      .then(res=>{
				this.transportationArr = res.data;
			})
			.catch(err=>{
				console.log(err)
			})
    },
    getStatistics(){
      statistics()
      .then(res => {
        this.detailNum = res.data;
      })
      .catch(err=>{
				console.log(err)
			})
    },
    search(data){
      this.searchParams = data
      this.page=1
      this.current=1
      this.getSearchData();
    },
    getSearchData(){
			const searchParams = {
				...this.searchParams,
				page:this.page,
				limit:this.limit
      }
      findByCondition(searchParams)
      .then( res=> {
        this.data = res.data.rows;
        this.data.forEach(ele=>{
					this.temperatureList.filter(item=>{
						if(item.value == ele.todayBodyTemperature){
							ele.todayBodyTemperatureDes = item.text
						}
					})
				})
        this.total = res.data.total
      })
      .catch(err=>{
        console.log(err)
      })
    },
		changePage(n){
      this.current = n;
      this.page = n;
      this.getSearchData()
    },
	}
}
</script>

<style>
	.num{
		height: auto;
		overflow: auto;
	}
	.num li{
		float: left;
		margin-right: 40px;
	}
	.red{
		color: red;
	}
</style>